import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { EffectsModule } from '@ngrx/effects';
import { FoodCostCalculatorPageRoutingModule } from './food-cost-calculator-routing.module';
import { FoodCostEffects } from '@inventory/effects/food-cost.effects';
import { FoodCostCalculatorPage } from './food-cost-calculator.page';
import { SharedModule } from '@shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { FoodCostCardComponent } from './components/food-cost-card/food-cost-card.component';
import { GraphTileComponent } from './components/graph-tile/graph-tile.component';
import { OverviewTileComponent } from './components/overview-tile/overview-tile.component';
import { FoodCostModalContainerComponent } from './components/food-cost-modal-container/food-cost-modal-container.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FoodCostTargetComponent } from './components/food-cost-target/food-cost-target.component';
import { FoodCostReportDeleteModalComponent } from './components/food-cost-report-delete-modal/food-cost-report-delete-modal.component';
import { FoodCostReportDetailsComponent } from './components/food-cost-report-details/food-cost-report-details.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    SharedModule,
    TranslateModule,
    FoodCostCalculatorPageRoutingModule,
    ScrollingModule,
    EffectsModule.forFeature([FoodCostEffects]),
  ],
  declarations: [
    FoodCostCalculatorPage,
    FoodCostCardComponent,
    GraphTileComponent,
    OverviewTileComponent,
    FoodCostModalContainerComponent,
    FoodCostTargetComponent,
    FoodCostReportDeleteModalComponent,
    FoodCostReportDetailsComponent,
  ],
})
export class FoodCostCalculatorPageModule {}
